export const MAX_IMPORT_DOCUMENTS = 20;

/**
 * Parses the free-text textarea into the `document_numbers` array sent to the backend.
 * Splits on commas and newlines, trims, drops empties and deduplicates — matching the
 * server-side normalization so our counts agree.
 *
 * NOTE: uses `s !== ''` rather than `.filter(Boolean)` on purpose. The literal string
 * `'0'` is a valid Xentral document number that the backend preserves, and `Boolean('0')`
 * is truthy anyway — but an empty/whitespace-only line must still be dropped.
 */
export const parseDocumentNumbers = (raw: string): Array<string> => {
  return Array.from(
    new Set(
      raw
        .split(/[,\n\r]+/)
        .map((value) => value.trim())
        .filter((value) => value !== ''),
    ),
  );
};
